import { configureStore } from '@reduxjs/toolkit';
import { createLogger } from 'redux-logger';

import friendsReducer, {
  getInitialFriendsState,
} from '../features/friends/slice/reducer';

import totalCounterReducer, {
  getInitialTotalCounterState,
} from '../features/totalCounter/slice';
import uiReducer, { getInitialUiState } from '../features/ui/slice';
import tilesReducer, { getInitialTilesState } from '../features/tiles/slice';
import userReducer, { getInitialUserState } from '../features/user/slice';
import storyReducer, { getInitialStoryState } from '../features/story/slice';
import triviaReducer, { getInitialTriviaState } from '../features/trivia/slice';
import surveysReducer, {
  getInitialSurveysState,
} from '../features/surveys/slice';
import searchReducer, {
  getInitialSearchState,
} from '../features/searchForm/slice';
import bannerReducer, { getInitialBannerState } from '../features/banner/slice';
import newsReducer, { getInitialNewsState } from '../features/news/slice';

import storageMiddleware, { loadState } from './middleware/storageMiddleware';

let isInitialized = false;

const init = (persistedState) => {
  isInitialized = true;

  const preloadedState = {
    search: getInitialSearchState(persistedState),
    ui: getInitialUiState(persistedState),
    trivia: getInitialTriviaState(persistedState),
    user: getInitialUserState(persistedState),
    friends: getInitialFriendsState(persistedState),
    totalCounter: getInitialTotalCounterState(persistedState),
    tiles: getInitialTilesState(persistedState),
    story: getInitialStoryState(persistedState),
    banner: getInitialBannerState(persistedState),
    news: getInitialNewsState(persistedState),

    ...(process.env.APP_TYPE !== 'schools' && {
      surveys: getInitialSurveysState(persistedState),
    }),
  };

  return configureStore({
    // ...(process.env.NODE_ENV === 'development' && {
    //   middleware: [...getDefaultMiddleware(), createLogger()],
    // }),
    middleware: (getDefaultMiddleware) =>
      [
        ...getDefaultMiddleware(),
        process.env.NODE_ENV === 'development' ? createLogger() : null,
        // createLogger(),
        storageMiddleware,
      ].filter(Boolean),

    preloadedState,
    reducer: {
      search: searchReducer,
      ui: uiReducer,
      trivia: triviaReducer,
      friends: friendsReducer,
      totalCounter: totalCounterReducer,
      tiles: tilesReducer,
      user: userReducer,
      story: storyReducer,
      banner: bannerReducer,
      news: newsReducer,
      ...(process.env.APP_TYPE !== 'schools' && {
        surveys: surveysReducer,
      }),
    },
  });
};

const DEFAULT_STATE = {
  totalCounter: {
    lastSeen: null,
  },
  ui: {
    customizeClicked: true,
    customizeGalleryTried: true,
    smallImageWarning: false,
    mode: 'gallery',
  },
  user: {
    experiment: {
      value: { scenario: { featureFlags: {} } },
      fetchedAt: 0,
    },
    engine: null,
  },
  story: {
    queue: [],
    shownMessagesIds: [],
    shown: {
      message: null,
      visits: null,
    },
  },
  banner: {},
};

export default init(loadState() || DEFAULT_STATE);
